module.exports = __webpack_public_path__ + "3f4aada20c50cc3b655f307ca74113e6.pdf";